export default "__VITE_ASSET__aT9QNbHj__"